module.exports = __webpack_public_path__ + "static/img/winter_pingguoPic.ca140622.png";